<template>
    <router-view/>
</template>

<style lang="scss">
@forward 'vuetify/settings' with (
  $utilities: false,
);

$primary-color: #402D85;
$primary-color-light: #b3a8d1;

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ===== Screen view globals (used by /screen/videos and /screen/photos) ===== */

body.screen-view {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: $primary-color;

  #app {
    min-height: 100vh;
    display: block;
  }

}

h1, h2, h3, h4, h5, h6, p {
  font-family: "aktiv-grotesk", sans-serif;
  font-style: normal;
}

.default-background-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}

.cheerzone-video-bar {
  width: 100%;
  object-fit: contain;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 3;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.start-button {
  display: flex;
  flex-direction: column;
  background-color: $primary-color;
  color: white;
  border: 2px solid white;
  border-radius: 10px;
  padding: 20px;
  font-size: 40px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: white;
    color: $primary-color;
  }
}

.button {
  display: flex;
  flex-direction: column;
  background-color: $primary-color;
  color: white;
  border: 1px solid white;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: white;
    color: $primary-color;
  }
}

// Verberg support widget op routes met meta.hideWidget: true
// Voeg hideWidget: true toe aan een route in router.js om de widget te verbergen
body.hide-widget {
  #intercom-container,
  .intercom-lightweight-app,
  #hubspot-messages-iframe-container,
  #freshworks-container,
  #drift-widget,
  #drift-widget-container {
    display: none !important;
  }
}

.video-div {
  position: relative;
  width: 100%;
  height: 100vh;
  video {
    bottom: 20%;
    border: none;
    width: 100%;
    height: 83%;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    background-color: $primary-color;
  }
  .video-placeholder {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 2;
  }
}
</style>
